function formatCartAttributes(propsObj) {
  return Object.entries(propsObj)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => ({ key: key, value: String(value) }));
}

/* Helper function to get original variant ID for outlet products */
/* -------------------------------------------------------------------------------------- */
function getOriginalVariantId(originalVariantIdsString, barcode) {
  if (!originalVariantIdsString || !barcode) {
    return null;
  }

  try {
    // Parse string format: [{SKU1:ID1},{SKU2:ID2},]
    // Remove brackets and trailing comma
    const cleanString = originalVariantIdsString.replace(/[\[\]]/g, '').replace(/,$/, '');
    
    if (!cleanString) {
      return null;
    }

    // Split by '},{' to get individual mappings
    const mappings = cleanString.split('},{');
    
    for (let mapping of mappings) {
      // Remove any remaining braces
      const cleanMapping = mapping.replace(/[{}]/g, '');
      // Split by ':' to get SKU and ID
      const parts = cleanMapping.split(':');
      
      if (parts.length === 2) {
        const sku = parts[0].trim();
        const variantId = parts[1].trim();
        
        // Check if SKU matches the barcode
        if (sku === barcode) {
          return variantId;
        }
      }
    }
    
    console.warn('[Outlet Product] SKU not found in original variant mappings:', barcode);
    return null;
  } catch (error) {
    console.error('[Outlet Product] Error parsing original variant IDs:', error);
    return null;
  }
}

let buttons = document.querySelectorAll(".c-button");
buttons.forEach((btn) => (btn.disabled = true));

buttons.forEach((btn) => {
  btn.disabled = false;
  if (!btn.classList.contains("unavailable")) {
    btn.classList.remove("c-button--disabled");
  }
  btn.querySelector(".c-button__loading")?.classList.add("display-none");
});

/* Add to cart - Product */
/* -------------------------------------------------------------------------------------- */
$("#normalAddToCartBtn").on("click", async function (event) {
  event.preventDefault();
  event.stopPropagation();
  var el = $(this),
    product_id = parseFloat(el.attr("data-product-variant-id")),
    product_quantity = parseFloat(el.attr("data-product-quantity"));
    productType = el.attr("data-product-properties");
    productCompare = el.attr("data-product-compare");
    productTagDiscount = el.attr("data-product-tag");
    productPickup = el.attr("data-pickup");
    productCategory = el.attr("data-product-category");
    productPrice = el.attr("data-price");
    productUrl = el.attr("data-product-url");
    pickupStoreId = el.attr("data-pickup-store-id");
    promoProducts = el.attr("data-has-promo");
    itemsPromo = $("[js-product-promo-item]");
    isBoxSelected = el.attr("data-is-box") ? JSON.parse(el.attr("data-is-box")) : false;
    unitPerBox = parseInt(el.attr('data-unit-per-box'), 10);
    productIsOutlet = el.attr("data-is-outlet");
    productBarcode = el.attr("data-variant-barcode");
    productVariant = el.attr("data-selected-original-variant") || el.attr("data-product-variant-id")

  $(".c-cart-notification [data-product-inventory-class-popup]").attr(
    "class",
    "c-cart-notification__badge-progress"
  );
  $("[js-product-template] [data-loader]").removeClass("d-none");
  $("[js-product-template] [data-add-to-cart-text]").addClass("d-none");

  try {
    let linesToAdd = [];

    linesToAdd.push({
      merchandiseId: `gid://shopify/ProductVariant/${product_id}`,
      quantity: product_quantity,
      productUrl: productUrl,
      attributes: formatCartAttributes({
        productType,
        productCompare,
        productTagDiscount,
        productPickup,
        pickupStoreId,
        promoProducts,
        productPrice,
        _outlet_product: productIsOutlet,
        _barcode: productBarcode,
        _category: productCategory,
        _selected_outlet_variant: productVariant
      })
    });

    if (itemsPromo.length > 0) {
      for (let i = 0; i < itemsPromo.length; i++) {
        var promoEl = $(itemsPromo[i]),
          promo_product_id = parseFloat(promoEl.attr("data-product-variant-id"));
        
        linesToAdd.push({
          merchandiseId: `gid://shopify/ProductVariant/${promo_product_id}`,
          quantity: product_quantity,
          attributes: formatCartAttributes({
            productType,
            productPickup,
            pickupStoreId,
            productFree: product_id,
          })
        });
      }
    }

    const response = await window.CartAPI.addOrUpdateItems(linesToAdd);
    console.log('Response:', response)

    addMiniCartNotification(product_id, promoProducts, response.addedQuantity);
    // $("[js-product-template] .js-product-message").addClass("d-none");
  } catch (error) {
    $("[js-product-template] .js-product-message").removeClass("d-none");
    $("[js-product-template] [text-message-warning]")
      .empty()
      .append(error.message);
  } finally {
    $("[js-product-template] [data-loader]").addClass("d-none");
    $("[js-product-template] [data-add-to-cart-text]").removeClass("d-none");
  }
});

$("#addAndGoCheckout").on("click", async function (event) {
  event.preventDefault();
  event.stopPropagation();
  var el = $(this),
    product_id = parseFloat(el.attr("data-product-variant-id")),
    product_quantity = parseFloat(el.attr("data-product-quantity"));
    productType = el.attr("data-product-properties");
    productCompare = el.attr("data-product-compare");
    productTagDiscount = el.attr("data-product-tag");
    productPickup = el.attr("data-pickup");
    productCategory = el.attr("data-product-category");
    productUrl = el.attr("data-product-url");
    pickupStoreId = el.attr("data-pickup-store-id");
    promoProducts = el.attr("data-has-promo");
    itemsPromo = $("[js-product-promo-item]");
    isBoxSelected = JSON.parse(el.attr("data-is-box"));
    unitPerBox = parseInt(el.attr('data-unit-per-box'), 10);
    productIsOutlet = el.attr("data-is-outlet");
    productBarcode = el.attr("data-variant-barcode");
    productVariant = el.attr("data-selected-original-variant") || el.attr("data-product-variant-id")

  $(".c-cart-notification [data-product-inventory-class-popup]").attr(
    "class",
    "c-cart-notification__badge-progress"
  );
  $("[js-product-template] [data-loader]").removeClass("d-none");
  $("[js-product-template] [data-add-to-cart-text]").addClass("d-none");

  try {
    let linesToAdd = [];

    linesToAdd.push({
      merchandiseId: `gid://shopify/ProductVariant/${product_id}`,
      quantity: product_quantity,
      productUrl: productUrl,
      attributes: formatCartAttributes({
        productType,
        productCompare,
        productTagDiscount,
        productPickup,
        pickupStoreId,
        promoProducts,
        _outlet_product: productIsOutlet,
        _barcode: productBarcode,
        _category: productCategory,
        _selected_outlet_variant: productVariant
      })
    });

    if (itemsPromo.length > 0) {
      for (let i = 0; i < itemsPromo.length; i++) {
        var promoEl = $(itemsPromo[i]),
          promo_product_id = parseFloat(promoEl.attr("data-product-variant-id"));
        
        linesToAdd.push({
          merchandiseId: `gid://shopify/ProductVariant/${promo_product_id}`,
          quantity: product_quantity,
          attributes: formatCartAttributes({
            productType,
            productPickup,
            pickupStoreId,
            productFree: product_id,
          })
        });
      }
    }

    const response = await window.CartAPI.addOrUpdateItems(linesToAdd);

    addMiniCartNotification(product_id, promoProducts, response.addedQuantity);
    // $("[js-product-template] .js-product-message").addClass("d-none");

    if (typeof window.navigateToCart === 'function') {
      window.navigateToCart();
    } else {
      location.href = `https://${window.CartAPI.domain}/cart`;
    }

  } catch (error) {
    $("[js-product-template] .js-product-message").removeClass("d-none");
    $("[js-product-template] [text-message-warning]")
      .empty()
      .append(error.message);
  } finally {
    $("[js-product-template] [data-loader]").addClass("d-none");
    $("[js-product-template] [data-add-to-cart-text]").removeClass("d-none");
  }
});

/* Product - Select variant */
/* -------------------------------------------------------------------------------------- */
$(".js-get-variant").on("click", function (event) {
  event.preventDefault();
  event.stopPropagation();
  var el = $(this),
    idProduct = el.attr("data-product-id"),
    urlProduct = el.attr("data-product-url"),
    metafieldVariant = el.attr("data-product-badge"),
    metafieldVariantAttribute = '[data-name="' + metafieldVariant + '"]',
    metafieldVariantSeals = el.attr("data-product-seals"),
    metafieldVariantAttributeSeals =
      '[data-name="' + metafieldVariantSeals + '"]',
    variantName = el
      .val()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase(),

    listVariants = $(".js-get-variant");
  el.closest("[js-product-form-variants]")
    .find(".js-get-variant")
    .removeClass("active")
    .removeAttr("checked");
  el.addClass("active").attr("checked", "checked");
  $("[data-product-price-text]").addClass("d-none");
  $("[data-product-invalid]").addClass("d-none");
  $(".js-notes-wrapper").removeClass("active");
  var option = [];

  let variantUnity = document.getElementById('variant-unity');
  let variantBox = document.getElementById('variant-box');
  let addToCartBtn = document.getElementById('normalAddToCartBtn');
  let addAndGoCheckout = document.getElementById('addAndGoCheckout');

  if (variantUnity && variantBox) {
    variantUnity.classList.add('active');
    variantBox.classList.remove('active');
  }

  addToCartBtn?.setAttribute('data-is-box', false);
  addAndGoCheckout?.setAttribute('data-is-box', false);

  let newProductImgs = document.querySelectorAll(".product-image-variant");
  let newSliderImgs = document.querySelectorAll(".slider-image-variant");
  let addedActive = false;
  newProductImgs.forEach((img, i) => {
    img.classList.add("d-none");
    img.classList.remove("active-variant");
    img.classList.remove("active");
    newSliderImgs[i].classList.add("d-none");
    newSliderImgs[i].classList.remove("active-variant");
    newSliderImgs[i].classList.remove("active");

    let alt = img.querySelector("img").alt;
    if (alt === variantName) {
      img.classList.remove("d-none");
      img.classList.add("active-variant");
      newSliderImgs[i].classList.remove("d-none");
      newSliderImgs[i].classList.add("active-variant");
      if (!addedActive) {
        newSliderImgs[i].classList.add("active");
        addedActive = true;
      }
    }
  });

  const slides = document.querySelector(".slides");
  slides.style.transform = `translateX(0%)`;

  for (var i = 0; i < listVariants.length; i++) {
    if ($(listVariants[i]).hasClass("active")) {
      var position = $(listVariants[i]).attr("data-position");
      var listVariantslength = listVariants.length + 1;
      for (var j = 1; j < listVariantslength; ++j) {
        if (position == j) {
          option[j] = $(listVariants[i]).val();
        }
      }
    }
  }
  $.getJSON(urlProduct + ".js", function (product) {
    console.log(product)
    var iProductVariants = product.variants;
    var currentVariant = _.find(iProductVariants, function (o) {
      return (
        o.option1 == option[1] &&
        o.option2 == option[2] &&
        o.option3 == option[3]
      );
    });
    if (currentVariant === undefined) {
      $("[data-product-invalid]").removeClass("d-none");
      $(".js-add-product-template")
        .addClass("c-button--disabled")
        .attr("disabled", 'disabled"');
      $("[data-add-to-cart-text]").text("Agotado");
    } else {
      var discount = currentVariant.compare_at_price - currentVariant.price
      var discount_mul = discount * 100.0
      var discount_percet = Math.round(discount_mul / currentVariant.compare_at_price)

      var qVariantId = currentVariant.id;
      var qVariantAvailable = currentVariant.available;
      var qVariantSku = currentVariant.sku;
      var qVariantPrice = new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
      }).format(currentVariant.price / 100);
      var qVariantComparePrice = new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
      }).format(currentVariant.compare_at_price / 100);
      $("[data-product-invalid]").addClass("d-none");
      $("#productSelect option").attr("selected", false);
      $("#productSelect option[value=" + qVariantId + "]").attr(
        "selected",
        true
      );
      $(".c-product__giftregistry")
        .find(".aaa-gift-registry-grid")
        .attr("data-variant-id", qVariantId);
      if (qVariantAvailable == false) {
        $(".js-add-product-template")
          .addClass("c-button--disabled")
          .attr("disabled", 'disabled"');
        $("[data-add-to-cart-text]").text("Agotado");
        $("[data-product-price-text]").removeClass("d-none");
      } else {
        // Check if this is an outlet product and get the original variant ID
        var finalVariantId = qVariantId;
        var isOutlet = $(".js-add-product-template").attr("data-is-outlet");
        
        if (isOutlet === "true") {
          var originalVariantIds = $(".js-add-product-template").attr("data-original-variant-ids");
          var originalVariantId = getOriginalVariantId(originalVariantIds, currentVariant.barcode);
          
          if (originalVariantId) {
            finalVariantId = originalVariantId;
            console.log('[Outlet Product] Using original variant ID:', originalVariantId, 'for outlet variant:', qVariantId);
          } else {
            console.warn('[Outlet Product] Could not find original variant ID, using outlet variant ID as fallback');
          }
        }
        
        $(".js-add-product-template")
          .attr("data-product-variant-id", qVariantId)
          .attr("data-variant-barcode", currentVariant.barcode)
          .attr("data-selected-outlet-variant", qVariantId)
          .attr("data-selected-original-variant", finalVariantId)
          .removeClass("c-button--disabled")
          .removeClass("unavailable")
          .removeAttr("disabled");
        $("[data-add-to-cart-text]").text("Agregar al carrito");
        $("[data-product-price-text]").addClass("d-none");
        let buttons = document.querySelectorAll(".text-of__btn");
        if (buttons.length > 0)
          buttons.forEach((btn) => (btn.innerHTML = btn.dataset.notDisabled));
      }
      if (currentVariant.compare_at_price >= currentVariant.price) {
        var discount_cart =
          currentVariant.compare_at_price - currentVariant.price;
        var discount_mul_cart = discount_cart * 100;
        var discount_percet_cart =
          discount_mul_cart / currentVariant.compare_at_price;
        $("[js-product-price-content]").addClass("price--on-sale");
        $(".js-add-product-template").attr(
          "data-product-tag",
          Math.floor(discount_percet_cart)
        );
        $(".js-add-product-template").attr(
          "data-product-compare",
          currentVariant.compare_at_price
        );
        $("[js-product-price-web]").removeClass("d-none");
        var saleBadge = document.querySelector('.badge__label-sale');
        if (saleBadge && discount_percet > 0) {
          saleBadge.textContent = discount_percet + '% OFF';
        }
      } else {
        $("[js-product-price-content]").removeClass("price--on-sale");
        $(".js-add-product-template").attr("data-product-tag", "");
        $(".js-add-product-template").attr("data-product-compare", "");
        $("[js-product-price-web]").addClass("d-none");
      }
      $("[data-product-price]").text(qVariantPrice);
      $("[data-product-price-compare]").text(qVariantComparePrice);
      $("[data-product-sku]").text(qVariantSku);
    }
    var newURL = urlProduct;
    window.history.replaceState(
      {
        path: newURL,
      },
      "",
      newURL
    );
  });
  $("[js-variant-metafields-badge]")
    .find(".s-main-product__text-images")
    .removeClass("active");
  $("[js-variant-metafields-badge]")
    .find(metafieldVariantAttribute)
    .first()
    .addClass("active");

  $("[js-variant-metafields-seals]")
    .find(".s-main-product-table-compare__logo-images")
    .removeClass("active");
  $("[js-variant-metafields-seals]")
    .find(metafieldVariantAttributeSeals)
    .first()
    .addClass("active");
  var titleSeals = $(
    "[js-variant-metafields-seals] .s-main-product-table-compare__logo-images"
  ).hasClass("active");
  if (titleSeals == true) {
    $("[js-variant-metafields-seals-title]").removeClass("d-none");
  } else {
    $("[js-variant-metafields-seals-title]").addClass("d-none");
  }

  //swiperImages.slideTo(variantIndex);
});

/*
let nextImgBtn = document.querySelector(".slider-navigation__next");
let prevImgBtn = document.querySelector(".slider-navigation__prev");
let thumbnailsSwiper = document.querySelector("#thumbnailsSwiper");

nextImgBtn.onclick = (e) => {
  let nextIndex;
  let thumbs = Array.from(thumbnailsSwiper.children);
  let variantThumbs = [];
  thumbs.forEach((thumb) =>
    !thumb.classList.contains("display-none") ? variantThumbs.push(thumb) : ""
  );
  let activeThumb = variantThumbs.find((thumb) =>
    thumb?.classList.contains("swiper-slide-thumb-active")
  );
  let currentIndex = variantThumbs.indexOf(activeThumb);

  if (variantThumbs.length > 1) {
    if (currentIndex + 1 === variantThumbs.length) {
      let thumbLabel = variantThumbs[0].ariaLabel.split("/");
      nextIndex = parseInt(thumbLabel[0].trim()) - 1;
    } else {
      let thumbLabel = variantThumbs[currentIndex + 1].ariaLabel.split("/");
      nextIndex = parseInt(thumbLabel[0].trim()) - 1;
    }

    swiperImages.slideTo(nextIndex);
  }
};
prevImgBtn.onclick = (e) => {
  let prevIndex;
  let thumbs = Array.from(thumbnailsSwiper.children);
  let variantThumbs = [];
  thumbs.forEach((thumb) =>
    !thumb.classList.contains("display-none") ? variantThumbs.push(thumb) : ""
  );
  let activeThumb = variantThumbs.find((thumb) =>
    thumb?.classList.contains("swiper-slide-thumb-active")
  );
  let currentIndex = variantThumbs.indexOf(activeThumb);

  if (variantThumbs.length > 1) {
    if (currentIndex + 1 === 1) {
      let thumbLabel =
        variantThumbs[variantThumbs.length - 1].ariaLabel.split("/");
      prevIndex = parseInt(thumbLabel[0].trim()) - 1;
    } else {
      let thumbLabel = variantThumbs[currentIndex - 1].ariaLabel.split("/");
      prevIndex = parseInt(thumbLabel[0].trim()) - 1;
    }

    swiperImages.slideTo(prevIndex);
  }
};
*/

/* Product - Input Quantity */
/* -------------------------------------------------------------------------------------- */
$("[js-product-template]").on("click", "[name=minus]", function (event) {
  event.preventDefault();
  /* Act on the event */
  var spinner = $(this),
    input = spinner.closest(".js-quantity").find('input[type="number"]'),
    min = input.attr("min"),
    max = input.attr("max"),
    oldValue = parseFloat(input.val());
  if (oldValue <= min) {
    var newVal = oldValue;
  } else {
    var newVal = oldValue - 1;
  }
  input.val(newVal);
  input.trigger("change");
  $(".js-add-product-template").attr("data-product-quantity", newVal);
});

$("[js-product-template]").on("click", "[name=plus]", function (event) {
  event.preventDefault();
  /* Act on the event */
  var spinner = $(this),
    input = spinner.closest(".js-quantity").find('input[type="number"]'),
    min = input.attr("min"),
    max = input.attr("max"),
    oldValue = parseFloat(input.val());
  if (oldValue >= max) {
    var newVal = oldValue;
  } else {
    var newVal = oldValue + 1;
  }
  input.val(newVal);
  input.trigger("change");
  $(".js-add-product-template").attr("data-product-quantity", newVal);
});

$("[js-product-template]").on(
  "keyup",
  '.quantity input[type="number"]',
  debounce(function () {
    var input = $(this),
      inputValue = parseFloat(input.val());
    $(".js-add-product-template").attr("data-product-quantity", inputValue);
  }, 500)
);

$("[js-product-template]").on(
  "change",
  '.c-quantity__input input[type="number"]',
  debounce(function () {
    var input = $(this),
      inputValue = parseFloat(input.val());
    $(".js-add-product-template").attr("data-product-quantity", inputValue);
  }, 500)
);

/* Product - Button View */
/* -------------------------------------------------------------------------------------- */
$("[js-button-view-more]").on("click", function (event) {
  event.preventDefault();
  /* Act on the event */
  var el = $(this);
  el.find("[js-button-view-text-1]").toggleClass("d-none");
  el.find("[js-button-view-text-2]").toggleClass("d-none");
  $("[js-content-view-more]").toggleClass("active");
  $("html, body").animate({
    scrollTop: $("#product-description-content").offset().top - 144,
  });
});

/* Product - height */
/* -------------------------------------------------------------------------------------- */
function stickyProduct(scrollPos) {
  var contentProduct = $("[js-product-details]");
  var contentProductSticky = $("[js-main-product-content-sticky]");
  var contentProductWidth = contentProductSticky.outerWidth();
  var contentProductPosition = contentProductSticky.position();
  var contentProductPositionLeft = contentProductPosition.left;
  var contentProductPositionTop = contentProductPosition.top;
  var header = $("#header-sticky .s-header__top");
  var minY = contentProduct.offset().top - header.outerHeight();
  var maxY =
    contentProduct.offset().top +
    contentProduct.outerHeight() -
    contentProductSticky.outerHeight() -
    header.outerHeight();

  contentProductSticky.css({
    width: contentProductWidth,
    left: contentProductPositionLeft,
  });

  if (scrollPos >= minY) {
    if (scrollPos <= maxY) {
      contentProductSticky.addClass("active-product-sticky");
    } else {
      contentProductSticky.removeClass("active-product-sticky");
      contentProduct
        .removeClass("align-items-start")
        .addClass("align-items-end");
    }
  } else {
    contentProductSticky.removeClass("active-product-sticky");
    contentProduct.addClass("align-items-start").removeClass("align-items-end");
  }
}

$(window).scroll(function () {
  lastKnownScrollPositionProduct = window.scrollY;
  stickyProduct(lastKnownScrollPositionProduct);
});